module.exports = __webpack_public_path__ + "static/media/login-mpd-icon@2x.6b25d338.png";


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/login-mpd-icon@2x.png
// module id = 867
// module chunks = 0